import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "lpu-schedule-skeleton",
      class: _vm.isMobile
        ? "lpu-schedule-skeleton_mobile"
        : "lpu-schedule-skeleton_full",
    },
    [_c(VSkeletonLoader, { attrs: { type: "text@14" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }